










































































// Composition
import { defineComponent, ref, Ref, watch } from '@nuxtjs/composition-api'

// Common
import { decodeHTMLEntities, extractElasticFieldString } from '@/common/utils/characters'
import { parseElasticTextObject } from '@/common/utils/parsing'

// Types
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

// Components
import IconFaSolidAngleLeft from '~icons/fa-solid/angle-left'
import IconFaSolidAngleRight from '~icons/fa-solid/angle-right'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'
import ProductPanelImage from '@/components/feature/search/results/searchtype/ProductPanelImage.vue'

export default defineComponent({
  components: {
    IconFaSolidAngleRight,
    IconFaSolidAngleLeft,
    IconFa6SolidXmark,
    ProductPanelImage,
  },

  props: {
    fields: {
      required: true,
      type: Object as () => ElasticFieldsInterface,
    },
    activeChiclet: {
      required: false,
      type: String,
      default: '',
    },
    infoPanelOpen: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const mappedChiclets: Ref<Array<any>> = ref([])
    const parsedChiclets = parseElasticTextObject(props.fields?.chiclets?.raw)

    const caroussel: any = ref(null)
    const slickOptions = {
      dots: false,
      adaptiveHeight: true,
      arrows: false,
      // infinite: false,
    }

    const mapChiclets = () => {
      mappedChiclets.value = parsedChiclets[props.activeChiclet]
    }
    mapChiclets()

    // Listen to a route change
    watch(props, () => {
      mapChiclets()
    })

    // caroussel functions
    const showNext = () => {
      if (caroussel.value === null || caroussel.value === undefined) {
        return
      }

      caroussel.value.next()
    }

    const showPrev = () => {
      if (caroussel.value === null || caroussel.value === undefined) {
        return
      }
      caroussel.value.prev()
    }

    return {
      decodeHTMLEntities,
      parseElasticTextObject,
      extractElasticFieldString,
      slickOptions,
      caroussel,
      showNext,
      showPrev,
      mappedChiclets,
    }
  },
})
